import { Skeleton } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router";
import LdcApi from "../../../../LdcApis";
import ProfileBar from "../ProfileBar";
import { BsArrowLeft } from "react-icons/bs";
const afterSclerotherapy = [
  {
    id: 1,
    title: "Stinging ",
    body: "at the time of treatment which settles within minutes.",
  },
  {
    id: 1,
    title: "Bruising",
    body: "around the treated area which disappears within 2 weeks.",
  },
  {
    id: 1,
    title: "Trapped blood",
    body: "-appears as dark tender lumps in the treated veins. This is expected  and can be drained within the first few weeks. If untreated this will improve within 6  months.",
  },
  {
    id: 1,
    title: "Dizziness ",
    body: "- may be experienced during the ultrasound examination and rarely with  treatment.",
  },
  {
    id: 1,
    title: "Leg aching",
    body: "in days following treatment is usually mild and can be treated with  ibuprofen and walking.",
  },
  {
    id: 1,
    title: "Urticaria ",
    body: "- localised itching and swelling of the skin may occur during the procedure  and resolves within 30 minutes.",
  },
  {
    id: 1,
    title: "Skin blisters",
    body: "- may develop due to the rubbing of the silicone band of the compression stockings against the thigh and can be avoided by changing the position  of the band daily.",
  },
  {
    id: 1,
    title: "Phlebitis ",
    body: "- inflammation of the treated vein which may be related to the trapped  blood. Usually resolves within days.",
  },
  {
    id: 1,
    title: "Darkening of the treated veins",
    body: "(1:10 – 1:100) shortly after treatment. Often improves within weeks but may take up to a year.",
  },
  {
    id: 1,
    title: "Matting ",
    body: "(1:10 – 1:100) – appearance of new fine spider veins in the treated areas.  They often disappear without further treatment within 3-6 months. Very rarely  matting is permanent.",
  },
  {
    id: 1,
    title: "Migraine/visual disturbances",
    body: " (1:100) – more common if you have a history of  migraines, usually resolves within 20 minutes.",
  },
];

const RareSideEffects = [
  {
    title: "Motor nerve damage paralysis",
    body: "(1:10,000) – permanent pigmentation / scarring /  keloid.",
  },
  {
    title: "Dermatitis",
    body: " inflammation/skin reaction – permanent pigmentation / scarring / keloid.",
  },
  {
    title: "Chest tightness",
    body: "(1:10 000) – can be due to vein spasm, usually resolves within 20  minutes.",
  },
  {
    title: "Hair growth",
    body: " – may occur even months after treatments and is localised and  temporary.",
  },
  {
    title: "Skin ulcers",
    body: "(1:1000) – small and painful, can occur weeks after treatment. Will heal  but may occasionally leave a scar.",
  },
  {
    title: "Allergic reaction",
    body: "– can range from mild to serious and life threatening.",
  },
  {
    title: "Deep Vein Thrombosis",
    body: "(DVT) (1:1000 – 1:10 000) – a clot in a deep vein (different to  the treated vein). Higher risk with prior history of DVT. A potentially dangerous  problem that can lead to the clot travelling to the lungs. Risk can be minimised by  wearing your compression stockings after treatment and walking daily as directed.",
  },
  {
    title: "Sensory nerve damage",
    body: "(1:1000 – 1:10 000) – may be temporary or permanent.  Usually improves within a few months.",
  },
  {
    title: "Intra-arterial injection",
    body: " (>1:10 000) – inadvertent injection into an artery which may  result in skin and muscle damage.",
  },
  {
    title: "Stroke ",
    body: "(0.01%) - a temporary or permanent loss of body functions following an abrupt interruption of blood flow to the brain. A potentially dangerous condition that can be life threatening. ",
  },
  {
    title: "Recurrence  ",
    body: "it is possible for the veins to recur and the need for further treatment may be necessary.",
  },
];
const EditFoamSclerotherapy = () => {
  let patientDetailsData = JSON.parse(
    localStorage.getItem("patientDetailsData")
  );
  let userInfo = JSON.parse(localStorage.getItem("user_info"));

  const { id, viewId } = useParams();

  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Foam Sclerotherapy Consent  - LDC";
  }, []);
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    LdcApi({
      method: "GET",
      url: `PatientConsentForm_Sclerotherapy/GetView_FoamSclerotherapy?Id=${viewId}`,
    })
      .then((response) => {
        if (response.data.length > 0) {
          console.log("response--->", response);
          setLoading(false);
          setRowData(response?.data[0]);
        } else {
          //  navigate('/diary');
        }
      })
      .catch((error) => {
        setLoading(false);
        //   navigate('/diary');
      });
  }, []);
  return (
    <div>
      <ProfileBar />
      <Container>
        <Card className="p-4">
          <h6 className="text-center form_heading my-4">
            Foam Sclerotherapy Consent Form
          </h6>
          {loading ? (
            <Skeleton />
          ) : (
            <Row className="p-3">
              <p>
                This form is designed to provide you with the information you
                need to make an informed decision on whether to undergo
                sclerotherapy. Please ask any questions prior to signing.{" "}
              </p>
              <div className="mt-2">
                <b>Purpose of Vein treatment: </b>
                <p>
                  By signing I hereby authorise the doctor and/or associates to
                  extract, ablate, inject or interrupt diseased veins for the
                  purpose of attempting to improve the symptomology and/or
                  appearance of the legs.{" "}
                </p>
              </div>
              <div className="mt-2">
                <b>Alternatives treatments</b>
                <p>
                  I understand that alternative treatment for varicose veins
                  exist, including conservative treatments (elastic stockings)
                  surgical stripping, vein ablation and vein litigation.
                </p>
              </div>
              <div className="mt-2">
                <b>Outcomes from treatment</b>
                <p>
                  By signing I understand that the practice of medicine and
                  surgery is not an exact science, and, therefore reputable
                  practitioners cannot guarantee results. No guarantee or
                  assurance has been given by anyone, as to the results that may
                  be obtained.
                </p>
              </div>

              <div className="mt-5">
                <b>Common side effects during / after sclerotherapy:</b>
                <ul>
                  {afterSclerotherapy.map((el, index) => (
                    <li key={index} className=" align-items-center my-1">
                      <b className="mr-1">{el.title}</b>
                      {el.body}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mt-5">
                <b>Rare side effects during / after sclerotherapy:</b>
                <ul>
                  {RareSideEffects.map((el, index) => (
                    <li key={index} className=" align-items-center my-1">
                      <b className="mr-1">{el.title}</b>
                      {el.body}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mt-5">
                <b>Informed Treatment Consent:</b>
                <ul>
                  <b>Patient </b>
                  <p className=" align-items-center my-1">
                    ➢ I have read this consent form and have adequately been
                    informed of the proposed sclerotherapy procedure and the
                    risks of treatment.
                  </p>
                  <p className=" align-items-center my-1">
                    ➢ Alternative methods of treatment and the
                    risks/eventualities of not treating my condition have been
                    discussed.
                  </p>{" "}
                  <p className=" align-items-center my-1">
                    ➢ I acknowledge that adequate time was provided for any
                    questions to be answered. I understand that the results
                    (improved or success to satisfaction or failure) cannot be
                    guaranteed and depend on various aspects individual to each
                    patient. There is a risk of recurrence of symptoms despite
                    treatment. I hereby authorise the doctor to perform any
                    treatment that may be deemed necessary, should he/she
                    encounter an unhealthy or unforeseen condition during the
                    course of the procedure.
                  </p>
                </ul>
              </div>

              <div className="pl-3">
                <Form.Group className="m-0 p-0 d-flex align-items-center">
                  <b className="mr-2  ">Patient Name: </b>
                  <div className="">
                    <input
                      className={`from_control    `}
                      type="text"
                      name="patientName"
                      value={rowData?.patientName}
                      // placeholder="name"
                    />
                  </div>
                </Form.Group>

                <Row className="pl-3">
                  <b className="mr-2  ">Patient Signature: </b>
                  <Col sm={12} className="mt-2">
                    <div className="view_sigPadContainer p-2 my-3 ">
                      <img
                        src={rowData?.patientSignature}
                        className="signature"
                      />
                    </div>
                  </Col>
                  {/* <span className="text-danger  ml-3">{validationError.URL === true && 'Field is required.'}</span> */}
                </Row>

                <Form.Group className="m-0 p-0 d-flex align-items-center ">
                  <b className="mr-2">Date: </b>
                  <div>
                    <input
                      className={`from_control    `}
                      type="text"
                      name="patientDate"
                      value={moment(rowData?.patientDate).format("DD/MM/YYYY")}
                      // placeholder="name"
                    />
                    <br />
                  </div>
                </Form.Group>
              </div>

              <ul>
                <b>Doctor </b>
                <p className=" align-items-center my-1">
                  ➢ I declare that I have personally explained the nature of the
                  patient’s condition, the need for treatment, the procedure to
                  be performed and the risks and alternatives outlined in this
                  consent form.
                </p>
                <p className=" align-items-center my-1">
                  ➢I have given the patient named above the opportunity to ask
                  questions which I believe I have answered to the patient’s
                  satisfaction.
                </p>{" "}
              </ul>
              <div>
                <Form.Group className="m-0 p-0 d-flex align-items-center">
                  <b className="mr-2  ">Doctor Name: </b>

                  <div>
                    <input
                      className={`from_control    `}
                      type="text"
                      name="doctorName"
                      value={rowData?.doctorName}

                      // placeholder="name"
                    />
                    <br />
                  </div>
                </Form.Group>
                <Row className="pl-3">
                  <b className="mr-2  ">Doctor Signature: </b>
                  <Col sm={12} className="mt-2">
                    <div className="view_sigPadContainer p-2 my-3 ">
                      <img
                        src={rowData?.doctorSignature}
                        className="signature"
                      />
                    </div>
                  </Col>
                </Row>
                <Form.Group className="m-0 p-0 d-flex align-items-center">
                  <b className="mr-2">Date: </b>
                  <div>
                    <input
                      className={`from_control    `}
                      type="text"
                      name="doctorDate"
                      value={moment(rowData?.doctorDate).format("DD/MM/YYYY")}

                      // placeholder="name"
                    />
                  </div>
                </Form.Group>
              </div>
            </Row>
          )}
        </Card>
        {userInfo.roleID == 10 ? (
          <Button
            className="px-3 no-print"
            onClick={() => {
              localStorage.setItem(
                "patientDetailsData",
                JSON.stringify({ ...patientDetailsData, tab: 0 })
              );

              navigate(`/profile/${id}`);
            }}
          >
            <BsArrowLeft /> Back
          </Button>
        ) : (
          <Button
            className="px-3 no-print"
            onClick={() => {
              localStorage.setItem(
                "patientDetailsData",
                JSON.stringify({ ...patientDetailsData, tab: 7 })
              );

              navigate(`/profile/${id}`);
            }}
          >
            <BsArrowLeft /> Back
          </Button>
        )}
      </Container>
    </div>
  );
};

export default EditFoamSclerotherapy;
